module.exports = __webpack_public_path__ + "media/images/menu/emission_nebulae-c165e510e2bec240f725651bdf7b44be.jpg";